import { withSandbox } from 'utils/withSandbox';

import type { CollectionOrderFindOne } from 'api';

import { SandboxAlert } from './SandboxAlert';
import { SandboxOrderPaymentEntry } from './SandboxOrderPaymentEntry';
import { sandboxT } from './translations';

type Props = {
  order: CollectionOrderFindOne;
  onSuccess: VoidFunction;
};

const SandboxOrderDetailsTestCaseSection = withSandbox(
  ({ order, onSuccess }: Props) => (
    <div className="flex flex-col">
      <SandboxAlert
        message={
          <>
            {sandboxT.orderTestCases.alert} {sandboxT.common.documentation.see}{' '}
            <a href="/docs/guide/sandbox#sandbox-payins">
              {sandboxT.common.documentation.label}
            </a>{' '}
            {sandboxT.common.documentation.forMoreDetails}
          </>
        }
      />
      {order.payments.map((payment) => (
        <SandboxOrderPaymentEntry
          orderUuid={order.uuid}
          key={payment.uuid}
          payment={payment}
          onSuccess={onSuccess}
        />
      ))}
    </div>
  )
);

export { SandboxOrderDetailsTestCaseSection };
